<template>
  <DrawNextActivityList />
</template>

<script>
import DrawNextActivityList from "../components/place/drawactivity/NextActivityList.vue";
export default {
  data() {
    return {};
  },
  components: {
    DrawNextActivityList,
  },
};
</script>
<style lang="" scoped></style>
